/// <reference types="vite/client" />

/**
 * 官网调用的接口地址（CONSOLE Worker / api.havorix.cn）。
 *
 * 生产环境跨源，需要服务端 ALLOWED_ORIGINS 放行 havorix.cn；
 * 本地开发默认指向 wrangler dev（8790），可用 VITE_CONSOLE_API_BASE 覆盖。
 */
export const API_BASE = (
  import.meta.env.VITE_CONSOLE_API_BASE ??
  (import.meta.env.DEV ? 'http://127.0.0.1:8790' : 'https://api.havorix.cn')
).replace(/\/+$/, '');
